// @ts-nocheck
import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    LoadRealTimePricingAndInventory,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";
import loadProductPricingAndInventory from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/LoadProductPricingAndInventory";
import { shouldProductLoadRealTime } from "@store/Framework/Common/Utilities/productUtilities";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, LoadRealTimePricingAndInventory, props => {
    if (!props.product) {
        return;
    }

    /* Store Custom Code - Start */
    if (props.product && !shouldProductLoadRealTime(props.product)) {
        props.pricingLoaded = props.inventoryLoaded = true;
        return;
    }
    /* Store Custom Code - End */

    props.dispatch(
        loadProductPricingAndInventory({
            product: props.product,
            variantChildren: props.variantChildren,
            productInfosById: props.productInfosById,
            styledOption: props.parameter.styledOption,
            waitForDataLoaded:
                !!props.product.variantTypeId &&
                (!getIsWebCrawler() ||
                    getSettingsCollection(props.getState()).websiteSettings.includeRealTimeInventoryAndPricingForSeo),
            onComplete: () => {
                props.pricingLoaded = props.inventoryLoaded = true;
            },
        }),
    );
});
